import type { IAnalyticsService, IAnalyticsAdapter } from './analytics.types'
import { AnalyticsService } from './analytics.service'

// let analyticsCache: IAnalyticsService | undefined

// const clients = new Map<string, IAnalyticsAdapter>()

// Singleton
class AnalyticsState {
  protected _analyticsCache: IAnalyticsService | undefined
  protected _clients = new Map<string, IAnalyticsAdapter>()

  public create(logging: boolean, windowId: string): IAnalyticsService {
    if (this._analyticsCache) return this._analyticsCache
    this._analyticsCache = new AnalyticsService(logging, windowId)
    return this._analyticsCache
  }

  public get(): IAnalyticsService {
    if (!this._analyticsCache) throw new Error('Analytics not initialized')
    return this._analyticsCache
  }

  public clients(): Map<string, IAnalyticsAdapter> {
    return this._clients
  }

  public clientSet(name: string, client: IAnalyticsAdapter): void {
    if (this._clients.has(name)) return
    this._clients.set(name, client)
  }

  public clientGet(name: string): IAnalyticsAdapter | undefined {
    return this._clients.get(name)
  }
}

export const analyticsState = new AnalyticsState()
